import React from "react";

export default function LinkedinIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
    >
      <path
        fill="currentColor"
        d="M0 1.801C0 .852.789.082 1.762.082h20.476c.973 0 1.762.77 1.762 1.72v20.56c0 .95-.79 1.72-1.762 1.72H1.762c-.973 0-1.762-.77-1.762-1.72V1.803Zm7.415 18.372V9.335H3.813v10.837h3.602ZM5.614 7.855c1.256 0 2.038-.833 2.038-1.873-.023-1.063-.782-1.872-2.014-1.872-1.232 0-2.038.809-2.038 1.872 0 1.04.782 1.873 1.99 1.873h.024Zm7.363 12.316V14.12c0-.323.024-.647.119-.878.26-.648.853-1.318 1.848-1.318 1.303 0 1.825.994 1.825 2.45v5.798h3.602V13.96c0-3.33-1.778-4.878-4.147-4.878-1.911 0-2.768 1.05-3.247 1.789v.037h-.024l.024-.037V9.335H9.375c.047 1.017 0 10.837 0 10.837h3.602Z"
      />
    </svg>
  );
}
